import React from "react";
import { Container } from "../styles/components/Global/Global";
import { Headline } from "../styles/components/Global/Text";
import {
  HeadlineContainer,
  ImageContainer,
  Image,
  GifWrapper,
  GifContainer,
} from "../styles/components/Galleries/Gif";

const HeadingGif = () => {
  return (
    <Container $justify="flex-end" $height="auto" $flex>
      <HeadlineContainer>
        <GifWrapper>
          <Headline $textAlign="left">Past</Headline>
          <Headline $textAlign="left">Meets</Headline>
        </GifWrapper>
        <Headline $textAlign="left">Present</Headline>
      </HeadlineContainer>
    </Container>
  );
};

export default HeadingGif;
